export enum PlacementManagerSurface {
  THEME_PAGE = 'theme-page',
  HOMEPAGE = 'homepage',
  STOREFRONT = 'storefront',
  CHECKOUT_AISLE = 'checkout_aisle',
  ORDER_STATUS_RECOMMENDATIONS = 'order_status_recommendations',
}

export const validSurfaceNameRouteParams = Object.values(PlacementManagerSurface).join('|')
